import request from '@/utils/request'

// 记录用户点击
export const logUserClickApi = (params) => request({
  url: '/bd/homepage/userOperation',
  method: 'post',
  params
})